export enum ScanMenuPage {
  MAIN = "MAIN",
  FREIGHT = "FREIGHT",
  RECORD_INBOUND = "RECORD_INBOUND",
  MANAGE_OUTBOUND = "MANAGE_OUTBOUND",
  INSPECTION = "INSPECTION",
  BOX_BREAK = "BOX_BREAK",
  DASHBOARD = "DASHBOARD",
}
